import React from 'react'
import { WidgetContext } from 'live/context/widget'

export interface UseJsonConfig {
    panels?: Configs['panels']
    displayWellName: string
    displaySpan: string
    id?: string
    type?: string
    changeConfig?: (field: string, value: any) => void
    reloadWidget?: (id: number | string) => void
}

export const useJsonConfig = (): UseJsonConfig => {
    const widgetContext = React.useContext(WidgetContext)
    const [cfg, setCfg] = React.useState<UseJsonConfig>(widgetContext?.chart?.option?.cfg ?? {})

    React.useEffect(() => {
        if (widgetContext?.chart?.options?.id) {
            setCfg({
                panels: widgetContext?.chart?.options?.cfg?.panels,
                displaySpan: widgetContext?.chart?.options?.cfg?.displaySpan,
                displayWellName: widgetContext?.chart?.options?.cfg?.displayWellName,
                id: widgetContext?.widget?.id,
                type: widgetContext?.widget?.type,
                reloadWidget: widgetContext?.chart?.options.reloadWidget,
                changeConfig: widgetContext?.chart?.options?.context?.actions?.changeConfig
            })
        }
    }, [widgetContext])

    return cfg
}
